import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DeviceEnrollPage } from '@/features/admin/devices/device-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Ajouter un site edge (ADR 0085) ; le mode kubeconfig (PKCS#12) reste replié ; enrôlements en attente. */
export const Route = createFileRoute('/$tenant/resources/devices/enroll')({ component: EnrollDeviceRoute });

function EnrollDeviceRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="devices"
      crumbs={[{ label: t('nav.items.devices') }, { label: t('admin.devices.edge.title') }]}
    >
      <DeviceEnrollPage tenantId={tenant} />
    </ConsoleShell>
  );
}
